import useAuth from 'src/careflow/ph-core/authentication/hook/useAuth';
import { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { usePatient } from 'src/careflow/ph-core/fhir-client/fhir-react';
import ProviderWindow from 'src/careflow/common/ProviderWindow';
import { CheckCircleOutline as CheckIcon } from '@mui/icons-material';
import { PatientWrapper } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Patient';
import useTenantConfigData from 'src/careflow/ph-core/multi-tenant/tenant/hook/useTenantConfigData';
import { ReferralService } from 'src/crs/referral/services/ReferralService';
import { CaseService } from 'src/crs/case/service/CaseService';

const DispositionComp = (props: any) => {
  const { record: data } = props?.others;
  const [patientId, setPatientID] = useState('');
  const [patient] = usePatient(patientId, { map: PatientWrapper });

  const user = useAuth();
  const { componentsData, configurations } = useTenantConfigData();
  const { workflowDisposition } = componentsData ?? {};

  const [userId, setUserId] = useState<string>('');
  const [fhirUserId, setFhirUserId] = useState<string>('');
  const [patientMrn, setPatientMrn] = useState<string>('');
  const [record, setRecord] = useState<any>({});

  useEffect(() => {
    const currentUser = user.getCurrentUser();
    if (currentUser.id === undefined) return;
    setUserId(currentUser.id);
    if (currentUser.user_fhir_uri === undefined) return;
    setFhirUserId(currentUser.user_fhir_uri);
  }, [user]);

  const fetchReferralRecord = async (id: any) => {
    const result: any = await ReferralService.getOne(id);
    setRecord(result);
  };

  const fetchCaseRecord = async (id: any) => {
    const result: any = await CaseService.getOne(id);
    setRecord(result);
  };

  useEffect(() => {
    if (data) {
      if (data?.recordReference === 'REFERRAL') {
        fetchReferralRecord(data?.recordId);
      } else if (data?.recordReference === 'CASE') {
        fetchCaseRecord(data?.recordId);
      }
    }
  }, [data]);

  useEffect(() => {
    if (record) {
      const patientFromReferral =
        record?.indexedFhirSubjectRefUri?.trim().slice('-36') ||
        record?.indexedSubjectFhirRefUri?.trim().slice('-36') ||
        record?.patientFhirUUID;
      setPatientID(patientFromReferral);
    }
  }, [record]);

  useEffect(() => {
    if (patient) {
      const tempMrn = patient?.getMRN(configurations?.mpi?.systemMrn)?.value;
      if (tempMrn) {
        setPatientMrn(tempMrn);
      }
    }
  }, [patient, configurations]);

  return (
    <div>
      <Grid container direction="column" alignItems="center" justifyContent="center">
        <Grid item>
          <CheckIcon fontSize="large" sx={{ color: 'green', marginRight: '10px' }} />
        </Grid>
        <Grid item>
          <Typography textAlign="center" style={{ fontSize: 12 }}>
            Workflow Completed
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        sx={{ mt: 1 }}
      >
        {workflowDisposition?.showProviderWindow ? (
          <ProviderWindow
            userId={userId}
            fhirUserId={fhirUserId}
            patientId={patientMrn}
            patientMiNTIdentifier={true}
            patientData={true}
          />
        ) : null}
      </Grid>
    </div>
  );
};

export default DispositionComp;
